/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/countries';
import '../common/currency_codes';
import '../common/payment';
import '../common/time';
import './model';
import '../bills/tender';
import '../common/instrument';
import '../esperanto/model/payments';
import '../common/currency';
import '../common/fee';
import '../common/fee_types';
import '../common/audit';
import './events/assessed_fee_events';
import '../common/entry_method';
import './events/requested_fee_events';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "feeplans": {
        "nested": {
          "FeePlanProduct": {
            "values": {
              "FEE_PLAN_PRODUCT_DEFAULT_DO_NOT_USE": 0,
              "REGISTER": 1,
              "CASH": 2,
              "MARKET": 3,
              "ORDER": 4,
              "EXTERNAL_API": 5,
              "BILLING": 6,
              "APPOINTMENTS": 7,
              "STORE": 8,
              "INVOICES": 9,
              "ONLINE_STORE": 10,
              "STARBUCKS": 11,
              "WHITE_LABEL": 12,
              "PAYROLL": 13,
              "CAPITAL": 14,
              "CAPITAL_BUSINESS_FREE": 50,
              "TERMINAL": 15,
              "EGIFTING": 16,
              "EGIFTING_FREE": 49,
              "REGISTER_HARDWARE": 17,
              "RESTAURANTS": 18,
              "RESTAURANTS_PAID": 19,
              "RETAIL": 20,
              "RETAIL_PAID": 21,
              "APPOINTMENTS_PAID": 22,
              "RESTAURANTS_POS_FREE": 23,
              "RESTAURANTS_POS_PAID": 24,
              "RETAIL_POS_FREE": 25,
              "RETAIL_POS_PAID": 26,
              "APPOINTMENTS_POS_FREE": 27,
              "APPOINTMENTS_POS_PAID": 28,
              "READER_SDK": 29,
              "REGISTER_T2": 30,
              "INSTALLMENTS_PREAPPROVAL": 31,
              "INSTALLMENTS_PROMO_6MO": 35,
              "INSTALLMENTS_PROMO_12MO": 36,
              "INSTALLMENTS_PROMO_18MO": 37,
              "INSTALLMENTS_PROMO_24MO": 38,
              "INSTALLMENTS_PLUS": 40,
              "INSTALLMENTS_DEFERRED_PAY": 46,
              "INSTALLMENTS_12MO_ZERO": 47,
              "INSTALLMENTS_24MO_ZERO": 48,
              "FELICA_ID": 32,
              "FELICA_TRANSPORTATION": 33,
              "FELICA_QP": 34,
              "INVOICES_DASHBOARD": 39,
              "INVOICES_PLUS": 52,
              "INVOICES_PAY_PAGE_FREE": 55,
              "INVOICES_PAY_PAGE_PLUS": 56,
              "ECOM_SOS_FREE": 41,
              "ECOM_SOS_PROFESSIONAL": 42,
              "ECOM_SOS_PERFORMANCE": 43,
              "ECOM_SOS_PREMIUM": 44,
              "ECOM_SOS_PERSONAL": 45,
              "RISK_MANAGER": 51,
              "BUYER_SUBSCRIPTIONS": 53,
              "CURRENCY_EXCHANGE": 54,
              "APP_SUBSCRIPTIONS": 57,
              "APP_SUBSCRIPTIONS_MARKETPLACE": 58,
              "FNB_KIOSK": 59,
              "GIFT_CARD_LOAD": 60,
              "BILLPAY": 61,
              "PAYMENT_LINKS": 62,
              "CASH_BUSINESS_ACCOUNTS": 63
            }
          },
          "FeePlanAttributes": {
            "fields": {
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 1,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 2,
                "rule": "optional"
              },
              "squareProduct": {
                "type": "squareup.common.payment.SquareProduct",
                "id": 3,
                "rule": "optional"
              },
              "effectiveAt": {
                "type": "squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "onboardedFrom": {
                "type": "squareup.common.time.DateTime",
                "id": 6,
                "rule": "optional"
              },
              "onboardedUntil": {
                "type": "squareup.common.time.DateTime",
                "id": 7,
                "rule": "optional"
              },
              "feePlanProduct": {
                "type": "squareup.feeplans.FeePlanProduct",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "GetFeeRateRequest": {
            "fields": {
              "attributes": {
                "type": "squareup.feeplans.FeePlanAttributes",
                "id": 1,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "feeRateConditions": {
                "type": "squareup.feeplans.FeeRateConditions",
                "id": 3,
                "rule": "optional"
              },
              "paymentToken": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "appPlatformAccount": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "tenderPricingMetadata": {
                "type": "squareup.bills.Tender.TenderPricingMetadata",
                "id": 6,
                "rule": "optional"
              },
              "instrumentType": {
                "type": "squareup.common.instrument.InstrumentType",
                "id": 7,
                "rule": "optional"
              },
              "paymentRecord": {
                "type": "squareup.esperanto.model.PaymentRecord",
                "id": 8,
                "rule": "optional"
              },
              "supplementaryFeeAssessmentDetails": {
                "type": "squareup.feeplans.SupplementaryFeeAssessmentDetails",
                "id": 9,
                "rule": "optional"
              }
            }
          },
          "SupplementaryFeeAssessmentDetails": {
            "fields": {
              "assessmentAmount": {
                "type": "squareup.common.Money",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "GetFeeRateResponse": {
            "fields": {
              "feeRate": {
                "type": "squareup.feeplans.TaxedFeeRate",
                "id": 1,
                "rule": "optional"
              },
              "feeRateEntry": {
                "type": "squareup.feeplans.FeeRateEntry",
                "id": 2,
                "rule": "repeated"
              },
              "unitToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "paymentToken": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "assessedFee": {
                "type": "squareup.feeplans.AssessedFee",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "AssessedFee": {
            "fields": {
              "totalFee": {
                "type": "squareup.common.FeeDetail",
                "id": 1,
                "rule": "optional"
              },
              "feeDetails": {
                "type": "squareup.common.FeeDetail",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "BatchGetFeeRatesRequest": {
            "fields": {
              "requests": {
                "type": "squareup.feeplans.GetFeeRateRequest",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "BatchGetFeeRatesResponse": {
            "fields": {
              "feeRates": {
                "type": "squareup.feeplans.TaxedFeeRate",
                "id": 1,
                "rule": "repeated"
              },
              "responses": {
                "type": "squareup.feeplans.GetFeeRateResponse",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "CostPlusFeePlan": {
            "fields": {
              "costPlusChangeType": {
                "type": "squareup.feeplans.CostPlusChangeType",
                "id": 1,
                "rule": "optional"
              },
              "costPlusFeeRate": {
                "type": "squareup.feeplans.CostPlusFeeRate",
                "id": 2,
                "rule": "optional"
              },
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 3,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 4,
                "rule": "optional"
              },
              "changedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "CostPlusChangeType": {
            "values": {
              "DEFAULT_COST_PLUS_CHANGE_TYPE_DO_NOT_USE": 0,
              "ENROLL": 1,
              "UNENROLL": 2
            }
          },
          "SupplementalFeePlan": {
            "fields": {
              "feePlanType": {
                "type": "squareup.common.feetypes.FeeplanType",
                "id": 1,
                "rule": "optional"
              },
              "supplementalChangeType": {
                "type": "squareup.feeplans.SupplementalFeePlan.SupplementalChangeType",
                "id": 2,
                "rule": "optional"
              },
              "supplementalFeeRate": {
                "type": "squareup.feeplans.SupplementalFeeRate",
                "id": 3,
                "rule": "optional"
              },
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 4,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 5,
                "rule": "optional"
              },
              "changedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "SupplementalChangeType": {
                "values": {
                  "DEFAULT_SUPPLEMENTAL_CHANGE_TYPE_DO_NOT_USE": 0,
                  "ENROLL": 1,
                  "UNENROLL": 2
                }
              }
            }
          },
          "FeePlan": {
            "fields": {
              "attributes": {
                "type": "squareup.feeplans.FeePlanAttributes",
                "id": 1,
                "rule": "optional"
              },
              "rates": {
                "type": "squareup.feeplans.ConditionalFeeRate",
                "id": 2,
                "rule": "repeated"
              },
              "expiresAt": {
                "type": "squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "CreateCustomFeePlanRequest": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "auditTrail": {
                "type": "squareup.common.audit.AuditTrail",
                "id": 2,
                "rule": "optional"
              },
              "tokenType": {
                "type": "squareup.feeplans.TokenType",
                "id": 5,
                "rule": "optional"
              },
              "planMetadata": {
                "type": "squareup.feeplans.PlanMetadata",
                "id": 6,
                "rule": "optional"
              },
              "expireHigherPrecedencePlans": {
                "type": "bool",
                "id": 7,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "customFeePlan": {
                "type": "squareup.feeplans.FeePlan",
                "id": 3
              },
              "costPlusFeePlan": {
                "type": "squareup.feeplans.CostPlusFeePlan",
                "id": 8
              },
              "supplementalFeePlan": {
                "type": "squareup.feeplans.SupplementalFeePlan",
                "id": 9
              }
            },
            "nested": {
              "plan": {
                "oneof": ["customFeePlan", "costPlusFeePlan", "supplementalFeePlan"]
              }
            }
          },
          "BatchCreateCustomFeePlanRequest": {
            "fields": {
              "feePlanRequest": {
                "type": "squareup.feeplans.CreateCustomFeePlanRequest",
                "id": 1,
                "rule": "repeated"
              },
              "expireHigherPrecedencePlans": {
                "type": "bool",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "upstreamRequestOu": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "dryRun": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "BatchCreateCustomFeePlanForMerchantsRequest": {
            "fields": {
              "customFeePlan": {
                "type": "squareup.feeplans.FeePlan",
                "id": 1,
                "rule": "required"
              },
              "merchantTokens": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "auditTrail": {
                "type": "squareup.common.audit.AuditTrail",
                "id": 3,
                "rule": "required"
              }
            }
          },
          "BatchCreateCustomFeePlanForMerchantsResponse": {
            "fields": {
              "batchCreateResponses": {
                "type": "squareup.feeplans.BatchCreateCustomFeePlanResponse",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "PlanMetadata": {
            "fields": {
              "requestedBy": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "approvedBy": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "approvedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "ExpireCustomFeePlanRequest": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "tokenType": {
                "type": "squareup.feeplans.TokenType",
                "id": 5,
                "rule": "optional"
              },
              "customFeePlan": {
                "type": "squareup.feeplans.FeePlanAttributes",
                "id": 2,
                "rule": "optional"
              },
              "feeplanRateId": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "expiresAt": {
                "type": "squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "auditTrail": {
                "type": "squareup.common.audit.AuditTrail",
                "id": 4,
                "rule": "optional"
              },
              "expireFutureEffective": {
                "type": "bool",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "BatchCreateCustomFeePlanResponse": {
            "fields": {
              "status": {
                "type": "squareup.feeplans.FeePlanResponseStatus",
                "id": 1,
                "rule": "optional"
              },
              "message": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "inserted": {
                "type": "squareup.feeplans.FeePlan",
                "id": 3,
                "rule": "repeated"
              },
              "expired": {
                "type": "squareup.feeplans.FeePlan",
                "id": 4,
                "rule": "repeated"
              },
              "failedRequests": {
                "type": "squareup.feeplans.CreateCustomFeePlanRequest",
                "id": 5,
                "rule": "repeated"
              },
              "conflicting": {
                "type": "squareup.feeplans.FeePlan",
                "id": 6,
                "rule": "repeated"
              }
            }
          },
          "FeePlanResponseStatus": {
            "values": {
              "DEFAULT_ERROR_TYPE_DO_NOT_USE": 0,
              "SUCCESS": 1,
              "INTERNAL_ERROR": 2,
              "INVALID_REQUEST": 3,
              "CONFLICTING_PLANS": 4,
              "DRY_RUN": 5,
              "PARTIAL_SUCCESS": 6
            }
          },
          "FeePlanResponse": {
            "fields": {
              "status": {
                "type": "squareup.feeplans.FeePlanResponseStatus",
                "id": 1,
                "rule": "optional"
              },
              "message": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "conflicting": {
                "type": "squareup.feeplans.FeePlan",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "GetFeePlansResponse": {
            "fields": {
              "feePlans": {
                "type": "squareup.feeplans.FeePlan",
                "id": 1,
                "rule": "repeated"
              },
              "token": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "tokenType": {
                "type": "squareup.feeplans.TokenType",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "GetUnitFeePlansRequest": {
            "fields": {
              "unitToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 2,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 3,
                "rule": "optional"
              },
              "effectiveAt": {
                "type": "squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "retrieveMarketplacePlans": {
                "type": "bool",
                "id": 7,
                "rule": "optional"
              },
              "includeAuditLogs": {
                "type": "bool",
                "id": 8,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "BatchGetUnitFeePlansRequest": {
            "fields": {
              "unitTokens": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              },
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 2,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 3,
                "rule": "optional"
              },
              "effectiveAt": {
                "type": "squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "includeAuditLogs": {
                "type": "bool",
                "id": 6,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "GetMerchantLevelFeePlansRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 2,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 3,
                "rule": "optional"
              },
              "effectiveAt": {
                "type": "squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "includeAuditLogs": {
                "type": "bool",
                "id": 6,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "BatchGetMerchantLevelFeePlansRequest": {
            "fields": {
              "merchantTokens": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              },
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 2,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 3,
                "rule": "optional"
              },
              "effectiveAt": {
                "type": "squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "includeAuditLogs": {
                "type": "bool",
                "id": 5,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "BatchGetFeePlansResponse": {
            "fields": {
              "responses": {
                "type": "squareup.feeplans.GetFeePlansResponse",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "GetDefaultFeePlansRequest": {
            "fields": {
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 1,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 2,
                "rule": "optional"
              },
              "effectiveAt": {
                "type": "squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "includeAuditLogs": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "BatchGetUnitCostplusDurationRequest": {
            "fields": {
              "unitTokens": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              },
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 2,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 3,
                "rule": "optional"
              },
              "windowStart": {
                "type": "squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "windowEnd": {
                "type": "squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "BatchGetUnitCostplusDurationResponse": {
            "fields": {
              "responses": {
                "type": "squareup.feeplans.UnitCostplusDuration",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "UnitCostplusDuration": {
            "fields": {
              "unitToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "activeDurationMillis": {
                "type": "int64",
                "id": 2,
                "rule": "optional"
              },
              "totalDurationMillis": {
                "type": "int64",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "CostPlusFeeplanAttribute": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "tokenType": {
                "type": "squareup.feeplans.TokenType",
                "id": 2,
                "rule": "optional"
              },
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 3,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "BatchGetUnitLastActiveCostplusRequest": {
            "fields": {
              "costplusFeePlanAttributes": {
                "type": "squareup.feeplans.CostPlusFeeplanAttribute",
                "id": 1,
                "rule": "repeated"
              },
              "windowStart": {
                "type": "squareup.common.time.DateTime",
                "id": 2,
                "rule": "optional"
              },
              "windowEnd": {
                "type": "squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "CostPlusPlanMapEntry": {
            "fields": {
              "costplusFeePlanAttributes": {
                "type": "squareup.feeplans.CostPlusFeeplanAttribute",
                "id": 1,
                "rule": "optional"
              },
              "costplusFeeRate": {
                "type": "squareup.feeplans.CostPlusFeeRate",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "BatchGetUnitLastActiveCostplusResponse": {
            "fields": {
              "responses": {
                "type": "squareup.feeplans.CostPlusPlanMapEntry",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "AssessRefundRequest": {
            "fields": {
              "totalRefundableAmount": {
                "type": "squareup.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "requestedRefundAmount": {
                "type": "squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "captureFeeAppliedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "existingFees": {
                "type": "squareup.feeplans.FeeBreakdown",
                "id": 4,
                "rule": "repeated"
              },
              "supplementaryRefundAssessmentDetails": {
                "type": "squareup.feeplans.SupplementaryRefundAssessmentDetails",
                "id": 5,
                "rule": "optional"
              },
              "existingServiceFees": {
                "type": "squareup.feeplans.FeeBreakdown",
                "id": 6,
                "rule": "repeated"
              },
              "assessedServiceFees": {
                "type": "squareup.feeplans.events.AssessedFee",
                "id": 7,
                "rule": "repeated"
              },
              "refundUuid": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              }
            }
          },
          "SupplementaryRefundAssessmentDetails": {
            "fields": {
              "captureFeeDetails": {
                "type": "squareup.common.FeeDetail",
                "id": 1,
                "rule": "repeated"
              },
              "aggregatedCaptureFeeDetail": {
                "type": "squareup.common.FeeDetail",
                "id": 2,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "refundPolicyOverride": {
                "type": "squareup.common.RefundPolicy",
                "id": 4,
                "rule": "optional"
              },
              "paymentOnHold": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "paymentToken": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "AssessRefundResponse": {
            "fields": {
              "assessedFee": {
                "type": "squareup.feeplans.AssessedFee",
                "id": 2,
                "rule": "optional"
              },
              "assessedServiceFee": {
                "type": "squareup.feeplans.AssessedFee",
                "id": 3,
                "rule": "optional"
              },
              "assessedServiceFees": {
                "type": "squareup.feeplans.events.AssessedFee",
                "id": 4,
                "rule": "repeated"
              }
            }
          },
          "FeeBreakdown": {
            "fields": {
              "feeRateId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "feeAmount": {
                "type": "squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "taxOnFeeAmount": {
                "type": "squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "entryMethod": {
                "type": "squareup.common.PayWithSquareEntryMethod",
                "id": 4,
                "rule": "optional"
              },
              "taxBreakdown": {
                "type": "squareup.feeplans.TaxBreakdown",
                "id": 5,
                "rule": "repeated"
              }
            }
          },
          "TaxBreakdown": {
            "fields": {
              "taxAmount": {
                "type": "squareup.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "taxRateDescription": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "AssessAsyncServiceFeesRefundRequest": {
            "fields": {
              "existingFees": {
                "type": "squareup.feeplans.FeeBreakdown",
                "id": 1,
                "rule": "repeated"
              },
              "existingAssessedFees": {
                "type": "squareup.feeplans.events.AssessedFee",
                "id": 3,
                "rule": "repeated"
              },
              "refundPolicyInfo": {
                "type": "squareup.feeplans.RefundPolicyInfo",
                "id": 2,
                "rule": "optional"
              },
              "refundUuid": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "AssessAsyncServiceFeesRefundResponse": {
            "fields": {
              "assessedServiceFees": {
                "type": "squareup.common.FeeDetail",
                "id": 1,
                "rule": "repeated"
              },
              "assessedFees": {
                "type": "squareup.feeplans.events.AssessedFee",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "BatchGetCustomFeePlanStatusRequest": {
            "fields": {
              "getCustomFeePlanStatusRequest": {
                "type": "squareup.feeplans.GetCustomFeePlanStatusRequest",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "GetCustomFeePlanStatusRequest": {
            "fields": {
              "includeUnitsInLookup": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "feeplanType": {
                "type": "squareup.common.feetypes.FeeplanType",
                "id": 4,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 1
              },
              "unitToken": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "token": {
                "oneof": ["merchantToken", "unitToken"]
              }
            }
          },
          "BatchGetCustomFeePlanStatusResponse": {
            "fields": {
              "responseStatus": {
                "type": "squareup.feeplans.BatchGetCustomFeePlanStatusResponse.ResponseStatus",
                "id": 1,
                "rule": "required"
              },
              "customPricingStatus": {
                "type": "squareup.feeplans.CustomPricingStatus",
                "id": 2,
                "keyType": "string"
              },
              "message": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "ResponseStatus": {
                "values": {
                  "SUCCESS": 1,
                  "INTERNAL_ERROR": 2,
                  "INVALID_REQUEST": 3
                }
              }
            }
          },
          "CustomPricingStatus": {
            "fields": {
              "enrolledInCustomPricing": {
                "type": "bool",
                "id": 1,
                "rule": "required"
              },
              "tokenType": {
                "type": "squareup.feeplans.TokenType",
                "id": 2,
                "rule": "required"
              },
              "unitsEnrolledInCustomPricing": {
                "type": "bool",
                "id": 3,
                "keyType": "string"
              }
            }
          },
          "BatchEnqueueRequestedFeeRequest": {
            "fields": {
              "requestedFees": {
                "type": "squareup.feeplans.events.RequestedCaptureFee",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "BatchEnqueueRequestedFeeResponse": {
            "fields": {
              "status": {
                "type": "squareup.feeplans.FeePlanResponseStatus",
                "id": 1,
                "rule": "optional"
              },
              "message": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "FeePlansService": {
            "methods": {
              "GetFeeRate": {
                "requestType": "squareup.feeplans.GetFeeRateRequest",
                "responseType": "squareup.feeplans.GetFeeRateResponse"
              },
              "BatchGetFeeRates": {
                "requestType": "squareup.feeplans.BatchGetFeeRatesRequest",
                "responseType": "squareup.feeplans.BatchGetFeeRatesResponse"
              },
              "CreateCustomFeePlan": {
                "requestType": "squareup.feeplans.CreateCustomFeePlanRequest",
                "responseType": "squareup.feeplans.FeePlanResponse"
              },
              "BatchCreateCustomFeePlan": {
                "requestType": "squareup.feeplans.BatchCreateCustomFeePlanRequest",
                "responseType": "squareup.feeplans.BatchCreateCustomFeePlanResponse"
              },
              "BatchCreateCustomFeePlanForMerchants": {
                "requestType": "squareup.feeplans.BatchCreateCustomFeePlanForMerchantsRequest",
                "responseType": "squareup.feeplans.BatchCreateCustomFeePlanForMerchantsResponse"
              },
              "ExpireCustomFeePlan": {
                "requestType": "squareup.feeplans.ExpireCustomFeePlanRequest",
                "responseType": "squareup.feeplans.FeePlanResponse"
              },
              "GetUnitFeePlans": {
                "requestType": "squareup.feeplans.GetUnitFeePlansRequest",
                "responseType": "squareup.feeplans.GetFeePlansResponse"
              },
              "GetMerchantLevelFeePlans": {
                "requestType": "squareup.feeplans.GetMerchantLevelFeePlansRequest",
                "responseType": "squareup.feeplans.GetFeePlansResponse"
              },
              "BatchGetUnitFeePlans": {
                "requestType": "squareup.feeplans.BatchGetUnitFeePlansRequest",
                "responseType": "squareup.feeplans.BatchGetFeePlansResponse"
              },
              "BatchGetMerchantLevelFeePlans": {
                "requestType": "squareup.feeplans.BatchGetMerchantLevelFeePlansRequest",
                "responseType": "squareup.feeplans.BatchGetFeePlansResponse"
              },
              "GetDefaultFeePlans": {
                "requestType": "squareup.feeplans.GetDefaultFeePlansRequest",
                "responseType": "squareup.feeplans.GetFeePlansResponse"
              },
              "BatchGetUnitCostplusDuration": {
                "requestType": "squareup.feeplans.BatchGetUnitCostplusDurationRequest",
                "responseType": "squareup.feeplans.BatchGetUnitCostplusDurationResponse"
              },
              "BatchGetUnitCostplusLastActivePlan": {
                "requestType": "squareup.feeplans.BatchGetUnitLastActiveCostplusRequest",
                "responseType": "squareup.feeplans.BatchGetUnitLastActiveCostplusResponse"
              },
              "AssessRefund": {
                "requestType": "squareup.feeplans.AssessRefundRequest",
                "responseType": "squareup.feeplans.AssessRefundResponse"
              },
              "BatchGetCustomFeePlanStatus": {
                "requestType": "squareup.feeplans.BatchGetCustomFeePlanStatusRequest",
                "responseType": "squareup.feeplans.BatchGetCustomFeePlanStatusResponse"
              },
              "BatchEnqueueRequestedFee": {
                "requestType": "squareup.feeplans.BatchEnqueueRequestedFeeRequest",
                "responseType": "squareup.feeplans.BatchEnqueueRequestedFeeResponse"
              },
              "AssessAsyncServiceFeesRefund": {
                "requestType": "squareup.feeplans.AssessAsyncServiceFeesRefundRequest",
                "responseType": "squareup.feeplans.AssessAsyncServiceFeesRefundResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feeplans?.nested?.FeePlanProduct && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeePlanAttributes && !$root.nested?.squareup?.nested?.feeplans?.nested?.GetFeeRateRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.SupplementaryFeeAssessmentDetails && !$root.nested?.squareup?.nested?.feeplans?.nested?.GetFeeRateResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.AssessedFee && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetFeeRatesRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetFeeRatesResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.CostPlusFeePlan && !$root.nested?.squareup?.nested?.feeplans?.nested?.CostPlusChangeType && !$root.nested?.squareup?.nested?.feeplans?.nested?.SupplementalFeePlan && !$root.nested?.squareup?.nested?.feeplans?.nested?.SupplementalFeePlan?.nested?.SupplementalChangeType && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeePlan && !$root.nested?.squareup?.nested?.feeplans?.nested?.CreateCustomFeePlanRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchCreateCustomFeePlanRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchCreateCustomFeePlanForMerchantsRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchCreateCustomFeePlanForMerchantsResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.PlanMetadata && !$root.nested?.squareup?.nested?.feeplans?.nested?.ExpireCustomFeePlanRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchCreateCustomFeePlanResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeePlanResponseStatus && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeePlanResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.GetFeePlansResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.GetUnitFeePlansRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetUnitFeePlansRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.GetMerchantLevelFeePlansRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetMerchantLevelFeePlansRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetFeePlansResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.GetDefaultFeePlansRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetUnitCostplusDurationRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetUnitCostplusDurationResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.UnitCostplusDuration && !$root.nested?.squareup?.nested?.feeplans?.nested?.CostPlusFeeplanAttribute && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetUnitLastActiveCostplusRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.CostPlusPlanMapEntry && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetUnitLastActiveCostplusResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.AssessRefundRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.SupplementaryRefundAssessmentDetails && !$root.nested?.squareup?.nested?.feeplans?.nested?.AssessRefundResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeeBreakdown && !$root.nested?.squareup?.nested?.feeplans?.nested?.TaxBreakdown && !$root.nested?.squareup?.nested?.feeplans?.nested?.AssessAsyncServiceFeesRefundRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.AssessAsyncServiceFeesRefundResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetCustomFeePlanStatusRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.GetCustomFeePlanStatusRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetCustomFeePlanStatusResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchGetCustomFeePlanStatusResponse?.nested?.ResponseStatus && !$root.nested?.squareup?.nested?.feeplans?.nested?.CustomPricingStatus && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchEnqueueRequestedFeeRequest && !$root.nested?.squareup?.nested?.feeplans?.nested?.BatchEnqueueRequestedFeeResponse && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeePlansService) {
  $root.addJSON(jsonData);
}

/**
 * A successor to SquareProduct. Used internally to represent combinations SquareProduct,
 * sub-product, and subscription status.  A combination of a subset of SquareProduct and
 * sub-product by subscription status.
 *
 * When adding a feeplan product, make sure to add the escalation policy and DRIs here:
 * https://docs.google.com/spreadsheets/d/1b93bg5yyzIKd6UKXBF-jHBjiI6h9XDF4xsoj53NB9PI/edit#gid=0
 *
 * SOURCE FeePlanProduct @ squareup/feeplans/service.proto at 38:1
 */
export const FeePlanProduct = $root.lookupEnum('squareup.feeplans.FeePlanProduct').values;
/**
 * Describes the attributes for a FeePlan (does not include FeeRateConditions so is not specific
 * enough to pick out a FeeRate).
 *
 * SOURCE FeePlanAttributes @ squareup/feeplans/service.proto at 252:1
 */
export const FeePlanAttributes = $root.lookupType('squareup.feeplans.FeePlanAttributes');
fixType(FeePlanAttributes, {
  country: {
    required: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(FeePlanAttributes);
/**
 * A get request to load a single TaxedFeeRate
 *
 * SOURCE GetFeeRateRequest @ squareup/feeplans/service.proto at 290:1
 */
export const GetFeeRateRequest = $root.lookupType('squareup.feeplans.GetFeeRateRequest');
fixType(GetFeeRateRequest, {
  attributes: {
    required: true
  },
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetFeeRateRequest);
/**
 * SOURCE SupplementaryFeeAssessmentDetails @ squareup/feeplans/service.proto at 319:1
 */
export const SupplementaryFeeAssessmentDetails = $root.lookupType('squareup.feeplans.SupplementaryFeeAssessmentDetails');
fixType(SupplementaryFeeAssessmentDetails);
Builder.createAndAttachToType(SupplementaryFeeAssessmentDetails);
/**
 * Response for the GetFeeRate service, contains the fee to charge
 *
 * SOURCE GetFeeRateResponse @ squareup/feeplans/service.proto at 324:1
 */
export const GetFeeRateResponse = $root.lookupType('squareup.feeplans.GetFeeRateResponse');
fixType(GetFeeRateResponse);
Builder.createAndAttachToType(GetFeeRateResponse);
/**
 * SOURCE AssessedFee @ squareup/feeplans/service.proto at 348:1
 */
export const AssessedFee = $root.lookupType('squareup.feeplans.AssessedFee');
fixType(AssessedFee);
Builder.createAndAttachToType(AssessedFee);
/**
 * A batch request to load a multiple TaxedFeeRate
 *
 * SOURCE BatchGetFeeRatesRequest @ squareup/feeplans/service.proto at 362:1
 */
export const BatchGetFeeRatesRequest = $root.lookupType('squareup.feeplans.BatchGetFeeRatesRequest');
fixType(BatchGetFeeRatesRequest);
Builder.createAndAttachToType(BatchGetFeeRatesRequest);
/**
 * Response for the BatchGetFeeRate service, contains the fees to charge
 *
 * SOURCE BatchGetFeeRatesResponse @ squareup/feeplans/service.proto at 367:1
 */
export const BatchGetFeeRatesResponse = $root.lookupType('squareup.feeplans.BatchGetFeeRatesResponse');
fixType(BatchGetFeeRatesResponse);
Builder.createAndAttachToType(BatchGetFeeRatesResponse);
/**
 * A minimal description of a cost plus rate feeplans will apply to all products
 *
 * SOURCE CostPlusFeePlan @ squareup/feeplans/service.proto at 382:1
 */
export const CostPlusFeePlan = $root.lookupType('squareup.feeplans.CostPlusFeePlan');
fixType(CostPlusFeePlan, {
  costPlusChangeType: {
    required: true
  },
  country: {
    required: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(CostPlusFeePlan);
/**
 * SOURCE CostPlusChangeType @ squareup/feeplans/service.proto at 393:1
 */
export const CostPlusChangeType = $root.lookupEnum('squareup.feeplans.CostPlusChangeType').values;
/**
 * A minimal description of any supplemental feeplan that will apply to all products
 *
 * SOURCE SupplementalFeePlan @ squareup/feeplans/service.proto at 418:1
 */
export const SupplementalFeePlan = $root.lookupType('squareup.feeplans.SupplementalFeePlan');
fixType(SupplementalFeePlan, {
  supplementalChangeType: {
    required: true
  },
  country: {
    required: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(SupplementalFeePlan);
/**
 * SOURCE SupplementalChangeType @ squareup/feeplans/service.proto at 429:3
 */
SupplementalFeePlan.SupplementalChangeType = $root.lookupEnum('squareup.feeplans.SupplementalFeePlan.SupplementalChangeType').values;
/**
 * New style create request
 *
 * SOURCE FeePlan @ squareup/feeplans/service.proto at 437:1
 */
export const FeePlan = $root.lookupType('squareup.feeplans.FeePlan');
fixType(FeePlan, {
  attributes: {
    required: true
  }
});
Builder.createAndAttachToType(FeePlan);
/**
 * The request to create a custom fee plan
 *
 * SOURCE CreateCustomFeePlanRequest @ squareup/feeplans/service.proto at 525:1
 */
export const CreateCustomFeePlanRequest = $root.lookupType('squareup.feeplans.CreateCustomFeePlanRequest');
fixType(CreateCustomFeePlanRequest, {
  token: {
    notEmpty: true
  },
  auditTrail: {
    required: true
  }
});
Builder.createAndAttachToType(CreateCustomFeePlanRequest);
/**
 * The request to create batch fee plans
 *
 * SOURCE BatchCreateCustomFeePlanRequest @ squareup/feeplans/service.proto at 553:1
 */
export const BatchCreateCustomFeePlanRequest = $root.lookupType('squareup.feeplans.BatchCreateCustomFeePlanRequest');
fixType(BatchCreateCustomFeePlanRequest);
Builder.createAndAttachToType(BatchCreateCustomFeePlanRequest);
/**
 * Request for internal API to create the same custom fee plan for N merchants.
 *
 * SOURCE BatchCreateCustomFeePlanForMerchantsRequest @ squareup/feeplans/service.proto at 562:1
 */
export const BatchCreateCustomFeePlanForMerchantsRequest = $root.lookupType('squareup.feeplans.BatchCreateCustomFeePlanForMerchantsRequest');
fixType(BatchCreateCustomFeePlanForMerchantsRequest);
Builder.createAndAttachToType(BatchCreateCustomFeePlanForMerchantsRequest);
/**
 * SOURCE BatchCreateCustomFeePlanForMerchantsResponse @ squareup/feeplans/service.proto at 571:1
 */
export const BatchCreateCustomFeePlanForMerchantsResponse = $root.lookupType('squareup.feeplans.BatchCreateCustomFeePlanForMerchantsResponse');
fixType(BatchCreateCustomFeePlanForMerchantsResponse);
Builder.createAndAttachToType(BatchCreateCustomFeePlanForMerchantsResponse);
/**
 * SOURCE PlanMetadata @ squareup/feeplans/service.proto at 597:1
 */
export const PlanMetadata = $root.lookupType('squareup.feeplans.PlanMetadata');
fixType(PlanMetadata);
Builder.createAndAttachToType(PlanMetadata);
/**
 * The request to expire a custom rate
 *
 * SOURCE ExpireCustomFeePlanRequest @ squareup/feeplans/service.proto at 604:1
 */
export const ExpireCustomFeePlanRequest = $root.lookupType('squareup.feeplans.ExpireCustomFeePlanRequest');
fixType(ExpireCustomFeePlanRequest, {
  auditTrail: {
    required: true
  }
});
Builder.createAndAttachToType(ExpireCustomFeePlanRequest);
/**
 * The response from create batch default fee plans
 *
 * SOURCE BatchCreateCustomFeePlanResponse @ squareup/feeplans/service.proto at 729:1
 */
export const BatchCreateCustomFeePlanResponse = $root.lookupType('squareup.feeplans.BatchCreateCustomFeePlanResponse');
fixType(BatchCreateCustomFeePlanResponse);
Builder.createAndAttachToType(BatchCreateCustomFeePlanResponse);
/**
 * SOURCE FeePlanResponseStatus @ squareup/feeplans/service.proto at 739:1
 */
export const FeePlanResponseStatus = $root.lookupEnum('squareup.feeplans.FeePlanResponseStatus').values;
/**
 * The response for a custom rate request
 *
 * SOURCE FeePlanResponse @ squareup/feeplans/service.proto at 750:1
 */
export const FeePlanResponse = $root.lookupType('squareup.feeplans.FeePlanResponse');
fixType(FeePlanResponse);
Builder.createAndAttachToType(FeePlanResponse);
/**
 * A response with a list of feeplans
 *
 * SOURCE GetFeePlansResponse @ squareup/feeplans/service.proto at 758:1
 */
export const GetFeePlansResponse = $root.lookupType('squareup.feeplans.GetFeePlansResponse');
fixType(GetFeePlansResponse);
Builder.createAndAttachToType(GetFeePlansResponse);
/**
 * A request for a list of all the fee plans for a given unit
 *
 * SOURCE GetUnitFeePlansRequest @ squareup/feeplans/service.proto at 768:1
 */
export const GetUnitFeePlansRequest = $root.lookupType('squareup.feeplans.GetUnitFeePlansRequest');
fixType(GetUnitFeePlansRequest, {
  unitToken: {
    notEmpty: true
  },
  country: {
    required: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(GetUnitFeePlansRequest);
/**
 * A request for a list of all the fee plans for multiple units. Max number of units allowed is 1000
 *
 * SOURCE BatchGetUnitFeePlansRequest @ squareup/feeplans/service.proto at 799:1
 */
export const BatchGetUnitFeePlansRequest = $root.lookupType('squareup.feeplans.BatchGetUnitFeePlansRequest');
fixType(BatchGetUnitFeePlansRequest, {
  country: {
    required: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(BatchGetUnitFeePlansRequest);
/**
 * A request for a list of all the custom merchant-level fee plans for a given merchant.
 * N.B. This will exclude unit-level custom fee plans
 *
 * SOURCE GetMerchantLevelFeePlansRequest @ squareup/feeplans/service.proto at 816:1
 */
export const GetMerchantLevelFeePlansRequest = $root.lookupType('squareup.feeplans.GetMerchantLevelFeePlansRequest');
fixType(GetMerchantLevelFeePlansRequest, {
  merchantToken: {
    notEmpty: true
  },
  country: {
    required: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(GetMerchantLevelFeePlansRequest);
/**
 * A request for a list of all the custom merchant-level fee plans for multiple merchant tokens.
 * Max number of allowed merchant tokens in one request is 1000.
 * N.B. This will exclude unit-level custom fee plans
 *
 * SOURCE BatchGetMerchantLevelFeePlansRequest @ squareup/feeplans/service.proto at 834:1
 */
export const BatchGetMerchantLevelFeePlansRequest = $root.lookupType('squareup.feeplans.BatchGetMerchantLevelFeePlansRequest');
fixType(BatchGetMerchantLevelFeePlansRequest, {
  country: {
    required: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(BatchGetMerchantLevelFeePlansRequest);
/**
 * A response with a list of GetFeePlans responses
 *
 * SOURCE BatchGetFeePlansResponse @ squareup/feeplans/service.proto at 845:1
 */
export const BatchGetFeePlansResponse = $root.lookupType('squareup.feeplans.BatchGetFeePlansResponse');
fixType(BatchGetFeePlansResponse);
Builder.createAndAttachToType(BatchGetFeePlansResponse);
/**
 * A request for a list of all the current default rates, for the products live in that country
 *
 * SOURCE GetDefaultFeePlansRequest @ squareup/feeplans/service.proto at 850:1
 */
export const GetDefaultFeePlansRequest = $root.lookupType('squareup.feeplans.GetDefaultFeePlansRequest');
fixType(GetDefaultFeePlansRequest, {
  country: {
    required: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(GetDefaultFeePlansRequest);
/**
 * TODO(Yash & Ayan): Maybe we can use {@link CostPlusFeeplanAttribute} here
 *
 * SOURCE BatchGetUnitCostplusDurationRequest @ squareup/feeplans/service.proto at 860:1
 */
export const BatchGetUnitCostplusDurationRequest = $root.lookupType('squareup.feeplans.BatchGetUnitCostplusDurationRequest');
fixType(BatchGetUnitCostplusDurationRequest, {
  country: {
    required: true
  },
  currencyCode: {
    required: true
  },
  windowStart: {
    required: true
  },
  windowEnd: {
    required: true
  }
});
Builder.createAndAttachToType(BatchGetUnitCostplusDurationRequest);
/**
 * SOURCE BatchGetUnitCostplusDurationResponse @ squareup/feeplans/service.proto at 871:1
 */
export const BatchGetUnitCostplusDurationResponse = $root.lookupType('squareup.feeplans.BatchGetUnitCostplusDurationResponse');
fixType(BatchGetUnitCostplusDurationResponse);
Builder.createAndAttachToType(BatchGetUnitCostplusDurationResponse);
/**
 * SOURCE UnitCostplusDuration @ squareup/feeplans/service.proto at 875:1
 */
export const UnitCostplusDuration = $root.lookupType('squareup.feeplans.UnitCostplusDuration');
fixType(UnitCostplusDuration);
Builder.createAndAttachToType(UnitCostplusDuration);
/**
 * Attributes of {@link FeeplanModel} that identify a costplus Feeplan model
 *
 * SOURCE CostPlusFeeplanAttribute @ squareup/feeplans/service.proto at 884:1
 */
export const CostPlusFeeplanAttribute = $root.lookupType('squareup.feeplans.CostPlusFeeplanAttribute');
fixType(CostPlusFeeplanAttribute, {
  token: {
    required: true
  },
  tokenType: {
    required: true
  },
  country: {
    required: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(CostPlusFeeplanAttribute);
/**
 * SOURCE BatchGetUnitLastActiveCostplusRequest @ squareup/feeplans/service.proto at 891:1
 */
export const BatchGetUnitLastActiveCostplusRequest = $root.lookupType('squareup.feeplans.BatchGetUnitLastActiveCostplusRequest');
fixType(BatchGetUnitLastActiveCostplusRequest, {
  windowStart: {
    required: true
  },
  windowEnd: {
    required: true
  }
});
Builder.createAndAttachToType(BatchGetUnitLastActiveCostplusRequest);
/**
 * SOURCE CostPlusPlanMapEntry @ squareup/feeplans/service.proto at 899:1
 */
export const CostPlusPlanMapEntry = $root.lookupType('squareup.feeplans.CostPlusPlanMapEntry');
fixType(CostPlusPlanMapEntry, {
  costplusFeePlanAttributes: {
    required: true
  }
});
Builder.createAndAttachToType(CostPlusPlanMapEntry);
/**
 * SOURCE BatchGetUnitLastActiveCostplusResponse @ squareup/feeplans/service.proto at 904:1
 */
export const BatchGetUnitLastActiveCostplusResponse = $root.lookupType('squareup.feeplans.BatchGetUnitLastActiveCostplusResponse');
fixType(BatchGetUnitLastActiveCostplusResponse, {
  responses: {
    required: true
  }
});
Builder.createAndAttachToType(BatchGetUnitLastActiveCostplusResponse);
/**
 * SOURCE AssessRefundRequest @ squareup/feeplans/service.proto at 908:1
 */
export const AssessRefundRequest = $root.lookupType('squareup.feeplans.AssessRefundRequest');
fixType(AssessRefundRequest);
Builder.createAndAttachToType(AssessRefundRequest);
/**
 * SOURCE SupplementaryRefundAssessmentDetails @ squareup/feeplans/service.proto at 954:1
 */
export const SupplementaryRefundAssessmentDetails = $root.lookupType('squareup.feeplans.SupplementaryRefundAssessmentDetails');
fixType(SupplementaryRefundAssessmentDetails);
Builder.createAndAttachToType(SupplementaryRefundAssessmentDetails);
/**
 * SOURCE AssessRefundResponse @ squareup/feeplans/service.proto at 982:1
 */
export const AssessRefundResponse = $root.lookupType('squareup.feeplans.AssessRefundResponse');
fixType(AssessRefundResponse);
Builder.createAndAttachToType(AssessRefundResponse);
/**
 * SOURCE FeeBreakdown @ squareup/feeplans/service.proto at 999:1
 */
export const FeeBreakdown = $root.lookupType('squareup.feeplans.FeeBreakdown');
fixType(FeeBreakdown);
Builder.createAndAttachToType(FeeBreakdown);
/**
 * SOURCE TaxBreakdown @ squareup/feeplans/service.proto at 1028:1
 */
export const TaxBreakdown = $root.lookupType('squareup.feeplans.TaxBreakdown');
fixType(TaxBreakdown);
Builder.createAndAttachToType(TaxBreakdown);
/**
 * SOURCE AssessAsyncServiceFeesRefundRequest @ squareup/feeplans/service.proto at 1041:1
 */
export const AssessAsyncServiceFeesRefundRequest = $root.lookupType('squareup.feeplans.AssessAsyncServiceFeesRefundRequest');
fixType(AssessAsyncServiceFeesRefundRequest, {
  existingAssessedFees: {
    required: true
  },
  refundPolicyInfo: {
    required: true
  },
  refundUuid: {
    required: true
  }
});
Builder.createAndAttachToType(AssessAsyncServiceFeesRefundRequest);
/**
 * SOURCE AssessAsyncServiceFeesRefundResponse @ squareup/feeplans/service.proto at 1063:1
 */
export const AssessAsyncServiceFeesRefundResponse = $root.lookupType('squareup.feeplans.AssessAsyncServiceFeesRefundResponse');
fixType(AssessAsyncServiceFeesRefundResponse);
Builder.createAndAttachToType(AssessAsyncServiceFeesRefundResponse);
/**
 * Custom Fee Plan Status Request
 *
 * SOURCE BatchGetCustomFeePlanStatusRequest @ squareup/feeplans/service.proto at 1145:1
 */
export const BatchGetCustomFeePlanStatusRequest = $root.lookupType('squareup.feeplans.BatchGetCustomFeePlanStatusRequest');
fixType(BatchGetCustomFeePlanStatusRequest);
Builder.createAndAttachToType(BatchGetCustomFeePlanStatusRequest);
/**
 * SOURCE GetCustomFeePlanStatusRequest @ squareup/feeplans/service.proto at 1149:1
 */
export const GetCustomFeePlanStatusRequest = $root.lookupType('squareup.feeplans.GetCustomFeePlanStatusRequest');
fixType(GetCustomFeePlanStatusRequest);
Builder.createAndAttachToType(GetCustomFeePlanStatusRequest);
/**
 * Custom Fee Plan Status Response
 *
 * SOURCE BatchGetCustomFeePlanStatusResponse @ squareup/feeplans/service.proto at 1161:1
 */
export const BatchGetCustomFeePlanStatusResponse = $root.lookupType('squareup.feeplans.BatchGetCustomFeePlanStatusResponse');
fixType(BatchGetCustomFeePlanStatusResponse);
Builder.createAndAttachToType(BatchGetCustomFeePlanStatusResponse);
/**
 * SOURCE ResponseStatus @ squareup/feeplans/service.proto at 1162:3
 */
BatchGetCustomFeePlanStatusResponse.ResponseStatus = $root.lookupEnum('squareup.feeplans.BatchGetCustomFeePlanStatusResponse.ResponseStatus').values;
/**
 * SOURCE CustomPricingStatus @ squareup/feeplans/service.proto at 1173:1
 */
export const CustomPricingStatus = $root.lookupType('squareup.feeplans.CustomPricingStatus');
fixType(CustomPricingStatus);
Builder.createAndAttachToType(CustomPricingStatus);
/**
 * SOURCE BatchEnqueueRequestedFeeRequest @ squareup/feeplans/service.proto at 1194:1
 */
export const BatchEnqueueRequestedFeeRequest = $root.lookupType('squareup.feeplans.BatchEnqueueRequestedFeeRequest');
fixType(BatchEnqueueRequestedFeeRequest, {
  requestedFees: {
    required: true
  }
});
Builder.createAndAttachToType(BatchEnqueueRequestedFeeRequest);
/**
 * SOURCE BatchEnqueueRequestedFeeResponse @ squareup/feeplans/service.proto at 1198:1
 */
export const BatchEnqueueRequestedFeeResponse = $root.lookupType('squareup.feeplans.BatchEnqueueRequestedFeeResponse');
fixType(BatchEnqueueRequestedFeeResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(BatchEnqueueRequestedFeeResponse);
/**
 * ///
 * RPC configurations
 * ///
 *
 * SOURCE FeePlansService @ squareup/feeplans/service.proto at 1768:1
 */
export const FeePlansService = $root.lookupService('squareup.feeplans.FeePlansService');